/*
 * V7 背景反馈：只给少数刻纹一次轻响应，不接管滚动、点击或现有 GSAP。
 * 气流：短高光沿线掠过；灯珠：灯罩依次亮起；风扇：叶片轻转后复位。
 * 无循环。离屏、页面隐藏、减少动态效果、分区移除时取消全部动画。
 * 独立 custom element 生命周期兼容 Shopify 编辑器的分区替换。
 */
(() => {
  'use strict';
  if (customElements.get('taztir-etching')) return;
  class TaztirEtching extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.jobs = new Set();
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || !this.abort) return;
      this.root = this.closest('taztir-story');
      this.mode = this.dataset.response || 'off';
      if (this.mode === 'off' || !this.root || !this.animate || !window.IntersectionObserver) return;
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.contrast = matchMedia('(forced-colors: active)');
      const signal = this.abort.signal;
      const stop = () => this.cancel();
      this.media.addEventListener('change', stop, { signal });
      this.contrast.addEventListener('change', stop, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.cancel(); }, { signal });
      // Observe the drawing itself: long editorial sections must not animate an offscreen ornament.
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) { this.cancel(); return; }
        if (!this.entered && ['enter', 'both'].includes(this.mode) && this.allowed()) {
          this.entered = true;
          this.play();
        }
      }, { threshold: 0.04 });
      this.observer.observe(this.querySelector('svg'));
      if (['interact', 'both'].includes(this.mode)) {
        // Native click also covers Enter / Space. Never prevent the real control's action.
        this.root.addEventListener('click', event => {
          if (event.target.closest('[data-choice], [data-day-link], [data-prev], [data-next], summary, .tz2-button')) this.play();
        }, { signal });
        this.root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.play(); }, { signal });
      }
    }
    allowed() {
      return this.visible && this.isConnected && !document.hidden && !this.media?.matches && !this.contrast?.matches && this.root?.dataset.motion === 'true' && this.root?.dataset.detail !== 'false';
    }
    run(node, frames, options) {
      if (!node) return;
      const job = node.animate(frames, { easing: 'cubic-bezier(.16,1,.3,1)', iterations: 1, fill: 'none', ...options });
      this.jobs.add(job);
      job.finished.catch(() => {}).finally(() => this.jobs.delete(job));
    }
    play() {
      if (!this.allowed() || performance.now() - (this.lastPlay || -2000) < 1400) return;
      this.cancel();this.lastPlay = performance.now();
      if (this.dataset.motif === 'airflow') {
        this.run(this.querySelector('.tz7-travel-line'), [{ opacity: 0 }, { opacity: 1, offset: .2 }, { opacity: 1, offset: .65 }, { opacity: 0 }], { duration: 1800 });
        this.querySelectorAll('.tz7-travel-line path').forEach((line,i) => this.run(line, [{ strokeDashoffset: '100' }, { strokeDashoffset: '-100' }], { duration: 1700, delay: i * 40, easing: 'linear' }));
      } else if (this.dataset.motif === 'led') {
        this.querySelectorAll('.tz7-led-dot rect:first-child').forEach((bead,i) => this.run(bead, [{ opacity: .16 }, { opacity: .8, offset: .4 }, { opacity: .16 }], { duration: 650, delay: (i % 20) * 28 }));
      } else if (this.dataset.motif === 'fan') {
        this.run(this.querySelector('.tz7-rotor'), [{ transform: 'rotate(0deg)' }, { transform: 'rotate(24deg)', offset: .65 }, { transform: 'rotate(0deg)' }], { duration: 1400 });
      }
    }
    cancel() { this.jobs?.forEach(job => job.cancel());this.jobs?.clear(); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);this.cancel();this.observer?.disconnect();this.observer = null;
      this.abort?.abort();this.abort = null;this.entered = false;this.visible = false;
    }
  }
  customElements.define('taztir-etching', TaztirEtching);
})();
